// src/services/trainingApi.js
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL}/trainings`;

const trainingAPI = {
    getAll: async () => {
        try {
            const response = await axios.get(API_URL);
            return response.data;
        } catch (error) {
            console.error('Error fetching trainings:', error);
            throw error;
        }
    },

    getById: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/${id}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching training ${id}:`, error);
            throw error;
        }
    },

    purchase: async (id) => {
        try {
            const response = await axios.post(`${API_URL}/${id}/purchase`);
            return response.data;
        } catch (error) {
            console.error(`Error purchasing training ${id}:`, error);
            throw error;
        }
    },

    getMyTrainings: async () => {
        try {
            const response = await axios.get(`${API_URL}/my-trainings`);
            return response.data;
        } catch (error) {
            console.error('Error fetching my trainings:', error);
            throw error;
        }
    },

    getRemainingDays: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/${id}/remaining-days`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching remaining days for training ${id}:`, error);
            throw error;
        }
    }
};

export default trainingAPI;